import '../../App.css';
import './Events.css';
import './Socia.css';
import Titleimage from '../Titleimage';


function Boletin() {


 
  return (

<div>
   <Titleimage heading='Boletin Informativo' />
   
<div className='mision'>
<div className='left'>
  <div className='img-container'>
  <img src='/images/img74.JPG' alt=''className='mision-me' loading='auto'/>  
  </div>
  </div>
<div className='right'>
  <h2>Nuestra Ultima Edición</h2>
  <p>Disfruta de nuestro boletin informativo Primavera 2025</p>
 
  <ul className="pdf-actions">
    <a
      href="/images/HWASA Newsletter Spring 2025.pdf"
    
      target="_blank"
      rel="noopener noreferrer"
      className="download-btn"
    >
      📥 Descargar PDF Edición Primavera 2025
    </a>
  </ul>
   
  <h3>Ediciones Pasadas</h3>
<ul>
  <li>
  <a
  href="/images/HWASA Newsletter Winter 2025.pdf"
    
      target="_blank"
      rel="noopener noreferrer"
      className="download-btn"
    >
      📥 Descargar PDF Edición Invierno 2025
   </a>
   </li>
   <li>
  <a
  href="/images/HWASA Newsletter Summer - Autumn 2025.pdf"
    
      target="_blank"
      rel="noopener noreferrer"
      className="download-btn"
    >
      📥 Descargar PDF Edición Verano - Otoño 2025
   </a>
   </li>
   <li>
  <a
  href="/images/HWASA Newsletter Spring 2024.pdf"
    
      target="_blank"
      rel="noopener noreferrer"
      className="download-btn"
    >
      📥 Descargar PDF Edición Primavera 2024
   </a>
   </li>
   <li>
  <a
  href="/images/HWASA Newsletter Autumn 2024.pdf"
    
      target="_blank"
      rel="noopener noreferrer"
      className="download-btn"
    >
      📥 Descargar PDF Edición Otoño 2024
   </a>
   </li>
</ul>


</div>

</div>

    
    
 </div>
     
     
  
  );
}


export default Boletin;

